import Vue from 'vue'
import VueRouter from 'vue-router'
import register from '../views/register.vue'

Vue.use(VueRouter)

const routes = [{
        path: '/',
        name: '',
        component: register
    },
    {
        path: '/register',
        name: 'register',
        component: register,
        meta: {
            title: '注册' // 标题设置
        },
    },
    {
        path: '/share',
        name: 'share',
        meta: {
            title: '全民数据' // 标题设置
        },
        // route level code-splitting
        // this generates a separate chunk (about.[hash].js) for this route
        // which is lazy-loaded when the route is visited.
        component: () => import( /* webpackChunkName: "about" */ '../views/share.vue')
    },
    {
        path: '/registersuccess',
        name: 'registersuccess',
        component: () => import('../views/registersuccess.vue')
    },
    {
        path: '/agreement',
        name: 'agreement',
        meta: {
            title: '全民数据用户协议' // 标题设置
        },
        component: () => import('../views/agreement.vue')
    },
    {
        path: '/registration',
        name: 'registration',
        meta: {
            title: '全民数据' // 标题设置
        },
        component: () => import('../views/registration.vue')
    },
    {
        path: '/download',
        name: 'download',
        meta: {
            title: '下载APP' // 标题设置
        },
        component: () => import('../views/download.vue')
    },
    {
        path: '/privacyAgreement',
        name: 'privacyAgreement',
        meta: {
            title: '隐私协议' // 标题设置
        },
        component: () => import('../views/privacyAgreement.vue')
    },
    {
        path: '/cancellation',
        name: 'cancellation',
        meta: {
            title: '注销账号' // 标题设置
        },
        component: () => import('../views/cancellation.vue')
    },
    {
        path: '/ActivateShareholderCard',
        name: 'ActivateShareholderCard',
        meta: {
            title: '激活股东卡' // 标题设置
        },
        component: () => import('../views/ActivateShareholderCard.vue')
    },
    {
        path: '/shareholderCard',
        name: 'shareholderCard',
        meta: {
            title: '介绍股东卡' // 标题设置
        },
        component: () => import('../views/shareholderCard.vue')
    },
    {
        path: '/dataPlay',
        name: 'dataPlay',
        meta: {
            title: '白皮书' // 标题设置
        },
        component: () => import('../views/dataPlay.vue')
    },
    {
        path: '/stockExchange',
        name: 'stockExchange',
        meta: {
            title: '交易所' // 标题设置
        },
        component: () => import('../views/stockExchange.vue')
    },
    {
        path: '/committee',
        name: 'committee',
        meta: {
            title: '国促会数工委' 
        },
        component: () => import('../views/journalism/committee.vue')
    },
    {
        path: '/listData',
        name: 'listData',
        meta: {
            title: '数字经济' 
        },
        component: () => import('../views/journalism/listData.vue')
    },
    {
        path: '/aboutUs',
        name: 'aboutUs',
        meta: {
            title: '关于本会' 
        },
        component: () => import('../views/journalism/aboutUs.vue')
    },
    {
        path: '/details',
        name: 'details',
        meta: {
            title: '详情' 
        },
        component: () => import('../views/journalism/details.vue')
    },
    {
        path: '/entryGuide',
        name: 'entryGuide',
        meta: {
            title: '会员服务' 
        },
        component: () => import('../views/journalism/entryGuide.vue')
    },
    {
        path: '/membershipApplication',
        name: 'membershipApplication',
        meta: {
            title: '入会申请' 
        },
        component: () => import('../views/journalism/membershipApplication.vue')
    },
    {
        path: '/memberEnterprises',
        name: 'memberEnterprises',
        meta: {
            title: '会员企业' 
        },
        component: () => import('../views/journalism/memberEnterprises.vue')
    },
    {
        path: '/memberDetails',
        name: 'memberDetails',
        meta: {
            title: '会员详情' 
        },
        component: () => import('../views/journalism/memberDetails.vue')
    },
    {
        path: '/guide',
        name: 'guide',
        meta: {
            title: '入会指南' 
        },
        component: () => import('../views/journalism/guide.vue')
    },
    {
        path: '/underReview',
        name: 'underReview',
        meta: {
            title: '入会申请' 
        },
        component: () => import('../views/journalism/underReview.vue')
    },
    {
        path: '/downloadPage',
        name: 'downloadPage',
        meta: {
            title: '下载' 
        },
        component: () => import('../views/newDownload/downloadPage.vue')
    },
    {
        path: '/fullNameData',
        name: 'fullNameData',
        meta: {
            title: '下载' 
        },
        component: () => import('../views/newDownload/fullNameData.vue')
    },
    {
        path: '/fuYuanProject',
        name: 'fuYuanProject',
        meta: {
            title: '下载' 
        },
        component: () => import('../views/newDownload/fuYuanProject.vue')
    },
    {
        path: '/sanAnYounong',
        name: 'sanAnYounong',
        meta: {
            title: '下载' 
        },
        component: () => import('../views/newDownload/sanAnYounong.vue')
    },
    {
        path: '/shareDownloadMall',
        name: 'shareDownloadMall',
        meta: {
            title: '下载' 
        },
        component: () => import('../views/newDownload/shareDownloadMall.vue')
    },
    {
        path: '/shareholderMall',
        name: 'shareholderMall',
        meta: {
            title: '下载' 
        },
        component: () => import('../views/newDownload/shareholderMall.vue')
    },
    {
        path: '/wineryDownload',
        name: 'wineryDownload',
        meta: {
            title: '下载' 
        },
        component: () => import('../views/newDownload/wineryDownload.vue')
    },
    {
        path: '/verificationCode',
        name: 'verificationCode',
        meta: {
            title: '获取验证码' 
        },
        component: () => import('../views/verificationCode/index.vue')
    },
    
]

const router = new VueRouter({
    mode: 'hash',
    base: process.env.BASE_URL,
    routes
})

export default router